export const SMarkersTableCell = {
  padding: { xs: '16px', md: '30px 16px' }
};
